<template>
  <el-container class="data-container">
    <el-header class="box add bb df">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>haacp标准生产流程</el-breadcrumb-item>
        <el-breadcrumb-item>模板库</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button size="medium" type="primary" @click="method_add"
        >新增数据</el-button
      >
    </el-header>
    <el-main class="p15 pt0">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <div class="df aic" style="margin-top: 20px">
          <el-form-item size="medium" style="flex: 0 0 20%" class="mr10">
            <el-input
              placeholder="关键词搜索"
              v-model="query.keyword"
              clearable
              class="input-with-select"
              @clear="search"
            >
            </el-input>
          </el-form-item>
          <el-button
            type="primary"
            @click="search"
            style="height: 34px; margin-bottom: 20px; border: none"
            class="mr10"
            >查询</el-button
          >
        </div>
      </el-form>
      <div class="box list">
        <el-table border :data="tableData" style="width: 100%">
          <!-- <el-table-column
            prop="head_id"
            min-width="120"
            :show-overflow-tooltip="true"
            label="ID"
            align="center"
          ></el-table-column> -->
          <el-table-column
            prop="category"
            min-width="120"
            :show-overflow-tooltip="true"
            label="分类"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="miniCategory"
            min-width="120"
            :show-overflow-tooltip="true"
            label="小分类"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdTime"
            min-width="100"
            :show-overflow-tooltip="true"
            label="创建时间"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.createdTime.replace("T", " ") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="isBind"
            min-width="120"
            :show-overflow-tooltip="true"
            label="是否绑定流程"
            align="center"
          >
            <template slot-scope="scope">
              <span
                :style="{
                  color: scope.row.isBind ? '#409EFF' : '#F56C6C',
                }"
                >{{ scope.row.isBind ? "是" : "否" }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="160" align="center">
            <template slot-scope="scope">
              <el-button @click="gotoAdd(scope.row)" type="success" size="mini"
                >绑定流程</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="i-page fr disib mt20">
          <el-pagination
            background
            :page-size="10"
            layout="total,prev, pager, next"
            :total="total"
            :current-page="query.page"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 新增/编辑对话框 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="500px"
        :closed="handleCancel"
      >
        <div class="item-content-fix">
          <el-form
            :model="form"
            :rules="data_rules"
            ref="formRef"
            label-width="100px"
          >
            <el-form-item label="分类名称" prop="category">
              <el-select
                v-model="form.category"
                placeholder="请选择"
                style="width: 100%"
                @change="handleSelectChange"
              >
                <el-option
                  v-for="item in configList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="小分类"
              prop="miniCategory"
              v-if="form.category"
            >
              <el-select
                v-model="form.miniCategory"
                placeholder="请选择"
                style="width: 100%"
                @change="miniCategoryChange"
              >
                <el-option
                  v-for="(item, index) in configList[checkedIndex].remark"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handleSelectAdd">确定</el-button>
          </div>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import api from "@/util/extra-api";

export default {
  data() {
    return {
      configList: [],
      // 页面数据
      query: {
        keyword: "",
        page: 1,
        limit: 15,
      },
      // 页面数据

      total: 0,

      tableData: [],
      // 对话框数据
      dialogVisible: false,
      dialogTitle: "新增数据",
      form: {
        category: "",
        miniCategoryCode: "",
        miniCategory: "",
      },
      data_rules: {
        category: [{ required: true, message: "请选择类型", trigger: "blur" }],
        miniCategory: [
          { required: true, message: "请选择小分类", trigger: "change" },
        ],
      },
      checkedIndex: 0,
      value: "",
    };
  },
  mounted() {
    this.method_init(this.query);
    this.getDicData("food_type");
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      return dateStr.replace("T", " ");
    },
    handleCancel() {
      this.dialogVisible = false;
      this.form = {
        category: "",
        miniCategoryCode: "",
        miniCategory: "",
      };
      this.$refs["formRef"].resetFields();
    },
    miniCategoryChange(value) {
      this.form.miniCategoryCode = this.configList[
        this.checkedIndex
      ].remark.filter((v) => v.label === value)[0].num;
      console.log(this.form, "form");
    },
    handleSelectChange(value) {
      this.checkedIndex = this.configList.findIndex((v) => v.value === value);
    },
    getDicData(typeCode) {
      api
        .get("/v1/wx/dic/data", {
          typeCode,
        })
        .then((res) => {
          if (res.code === 200) {
            // console.log(res);
            this.configList = res.data.map((v) => {
              return {
                ...v,
                value: v.label,
                remark: JSON.parse(v.remark).map((val) => {
                  return {
                    ...val,
                    value: val.name,
                    label: val.name,
                    checked: false,
                  };
                }),
              };
            });
            console.log(this.configList, "this.configList ");
          }
        });
    },
    method_init(params) {
      // 初始化数据，实际应该调用接口

      api.get("/v1/pc/foodHaccpTemplate/selectList", params).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;

          // console.log(this.tableData);
        }
      });
      // console.log("初始化数据", params);
      // 模拟数据
      // this.data_tableData = [
      //   {
      //     head_id: "1",
      //     head_name: "示例数据1",
      //     head_status: "active",
      //     head_createTime: "2023-01-01",
      //     head_type: "类型一",
      //     head_description: "这是一个示例数据",
      //   },
      //   {
      //     head_id: "2",
      //     head_name: "示例数据2",
      //     head_status: "inactive",
      //     head_createTime: "2023-01-02",
      //     head_type: "类型二",
      //     head_description: "这是另一个示例数据",
      //   },
      // ];
    },

    search() {
      this.query.page = 1;
      this.method_init(this.query);
    },
    currentChange(page) {
      this.query.page = page;
      this.method_init(this.query);
    },
    gotoAdd(row) {
      console.log(row, "测试");
      console.log(this.$router);

      this.$router.push({ name: "hACCPReference-add", query: { id: row.id } });
    },
    handleSelectAdd() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          api
            .post("/v1/pc/foodHaccpTemplate/selectAdd", this.form)
            .then((res) => {
              if (res.code === 200) {
                this.method_init(this.query);
                this.handleCancel();
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    method_add() {
      this.dialogTitle = "新增数据";
      this.data_form = {
        id: "",
        name: "",
        type: "",
        status: "active",
        description: "",
      };
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.data-container {
  overflow-x: hidden;
  .add {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /deep/ .el-input-group__append .el-button--primary .el-icon-search {
    color: #fff;
  }
}

.add-btn {
  flex: 0 0 200px;
}

.i-page {
  text-align: right;
  margin-top: 20px;
}

.item-content-fix {
  /deep/.el-form-item__content {
    width: calc(100% - 120px) !important;
    box-sizing: border-box;
  }
}

.custom-dialog {
}
</style>